// extracted by mini-css-extract-plugin
export default {"register-select":"regioRegister_register-select__2zngd"};